<template>
  <div>
    <PortDetail ref="PortDetail"></PortDetail>
    <EditPort ref="EditPort" v-on:editComplete="getPorts()"></EditPort>
    <Alert v-if="ports.error" type="warning" show-icon>获取端口数据失败</Alert>
    <Table
      v-else
      border
      size="small"
      :loading="ports.loading"
      ref="subnetTable"
      :data="ports.data"
      :columns="ports.columns">
    </Table>
    <div style="margin: 10px 0; overflow: hidden;">
      <div style="float: right;">
        <page
          :total="ports.count"
          :current="ports.page"
          :page-size="ports.size"
          @on-change="getPorts"></page>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrivateCloudPort, deletePrivateCloudPort } from '@/api/private-cloud/port'
import EditPort from './port-edit'
import PortDetail from './port-detail'

export default {
  name: 'port-list',
  components: {
    EditPort,
    PortDetail
  },
  data () {
    return {
      ports: {
        data: [],
        columns: [
          {
            title: '端口名称',
            align: 'center',
            minWidth: 130,
            tooltip: true,
            render: (h, params) => {
              let name = params.row.name
              if (!name) {
                name = '无'
              }
              return h('div', name)
            }
          },
          {
            title: '固定IP',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              const fixedIps = params.row.fixed_ips
              let result = []
              for (let i in fixedIps) {
                result.push(h('p', fixedIps[i].ip_address))
              }
              return h('div', result)
            }
          },
          {
            title: 'MAC地址',
            align: 'center',
            minWidth: 160,
            tooltip: true,
            key: 'mac_address'
          },
          {
            title: '连接设备',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'device_owner'
          },
          {
            title: '状态',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let status = params.row.status
              let color = status === 'ACTIVE' ? 'success'
                : status === 'DOWN' || status === 'BUILD' ? 'warning'
                  : status === 'ERROR' ? 'error'
                    : 'warning'
              let text = status === 'ACTIVE' ? '运行'
                : status === 'BUILD' ? '构建中'
                  : status === 'DOWN' ? 'Down'
                    : status === 'ERROR' ? '错误'
                      : status
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '管理状态',
            align: 'center',
            minWidth: 70,
            key: 'admin_state_up',
            render: (h, params) => {
              let res = '是'
              if (!params.row.admin_state_up) {
                res = '否'
              }
              return h('span', res)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 190,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.PortDetail.getInfo(params.row.id)
                    }
                  }
                }, '详情'),
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.EditPort.openModifyModal(params.row.id)
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        error: false,
        loading: false
      }
    }
  },
  props: {
    network_id: {
      type: String,
      required: true
    }
  },
  watch: {
    'network_id' () {
      if (this.network_id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getPorts()
    },
    getPorts (value = 1) {
      this.ports.page = value
      this.ports.loading = true
      getPrivateCloudPort({ network_id: this.network_id, page: this.ports.page, size: this.ports.size }).then(res => {
        this.ports.error = false
        let result = res.data
        this.ports.data = result.results
        this.ports.count = result.count
        this.ports.loading = false
      }).catch(res => {
        this.ports.error = true
        this.ports.loading = false
      })
    },
    // 删除端口
    delete (row) {
      deletePrivateCloudPort(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getPorts()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
